module.exports = __webpack_public_path__ + "static/media/video-blue.71a16b1b.svg";